// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Yoa7E","container":"styles_container__NfJEe","text":"styles_text__gcDd3"};